/* eslint-disable import/prefer-default-export */
export const SYSTEM = 'system' as const;
export const VISITOR = 'visitor' as const;
export const OPERATOR = 'operator' as const;
export const TYPING = 'typing' as const;
